import type { OnInit } from '@angular/core';
import { Component, HostBinding, Input } from '@angular/core';
import {
  BackgroundDirective,
  BackgroundSettings,
  ResponsiveSettings,
} from '@legacy/common-ui-shared';

import { ContentTheme } from '../../models';
import { ImageComponent } from '../image/image.component';
import { BrandHeaderComponent } from '../brand-header/brand-header.component';

@Component({
  selector: 'wl-partial-jumbotron',
  templateUrl: './jumbotron.component.html',
  styleUrls: ['./jumbotron.component.ed.scss'],
  standalone: true,
  imports: [ImageComponent, BrandHeaderComponent, BackgroundDirective],
})
export class PartialJumbotronComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() theme: ContentTheme = 'default';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() backgroundSettings?: BackgroundSettings;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() heading?: string | undefined;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() subheading?: string | undefined;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showButtonsInHeading? = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() inlineHeadings?: boolean | undefined = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() anchorPoint?: string | undefined;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() mobileTopImage?: boolean | undefined = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() layoutButtonsInline?: boolean = false;

  @HostBinding('attr.id') get id() {
    return this.anchorPoint;
  }

  mobileImage: ResponsiveSettings | undefined;

  ngOnInit() {
    this.mobileImage = this.getMobileImage();
  }

  getMobileImage(): ResponsiveSettings | undefined {
    if (this.backgroundSettings?.useDesktopBackgroundAsFallback) {
      if (this.backgroundSettings.mobile?.src) {
        return this.backgroundSettings.mobile;
      }
      return this.backgroundSettings.desktop;
    }
    return this.backgroundSettings?.mobile;
  }
}
